export default __webpack_public_path__ + "static/6-687bd930da03433c9c6553363fe81043.png";